import React from 'react';
import ReactDOM from 'react-dom';
import * as ReactDOMClient from 'react-dom/client';
import Chart from 'chart.js/auto';

// NOTE: @tanstack/react-query is now bundled with react-app.js (not here)
// to ensure hooks use the same React instance as createRoot

declare global {
  interface Window {
    React: typeof React;
    ReactDOM: typeof ReactDOM & { createRoot: typeof ReactDOMClient.createRoot };
    Chart: typeof Chart;
    __LEGACY_RUNTIME_LOADED__: boolean;
  }
}

console.log('[LEGACY_RUNTIME] Initializing bundled React runtime shim...');

window.React = React;

window.ReactDOM = {
  ...ReactDOM,
  createRoot: ReactDOMClient.createRoot,
} as typeof ReactDOM & { createRoot: typeof ReactDOMClient.createRoot };

window.Chart = Chart;

window.__LEGACY_RUNTIME_LOADED__ = true;

console.log('[LEGACY_RUNTIME] React runtime shim loaded successfully:', {
  React: typeof window.React,
  ReactDOM: typeof window.ReactDOM,
  'ReactDOM.createRoot': typeof window.ReactDOM.createRoot,
  Chart: typeof window.Chart,
});

export { React, ReactDOM, Chart };
